import React, { useState } from 'react'

import { Box } from '@mui/material'

import {
  BookingAddress,
  useGetBookingAddressesAttachmentsDescriptionQuery,
} from 'generated/graphql'
import { usePermission } from 'providers'

import AddressAttachmentsAccordion from './AddressAttachmentsAccordion'

interface BookingAddressAttachmentsProps {
  bookingId: string | null
}

const BookingAddressAttachments = (props: BookingAddressAttachmentsProps) => {
  const { bookingId } = props
  const [isAllowToViewBookingAddresses] = usePermission('ViewBookingAddresses')

  const [expanded, setExpanded] = useState<string | false>(false)

  const { loading: addressesLoading, data: addressesData } =
    useGetBookingAddressesAttachmentsDescriptionQuery({
      variables: {
        bookingId: Number(bookingId),
      },
      skip: !isAllowToViewBookingAddresses,
    })

  const addresses = addressesData?.bookingAddresses

  const handleChange = (panel: string) => (_event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <Box>
      {addressesLoading
        ? 'Loading...'
        : addresses?.map((a) => (
            <AddressAttachmentsAccordion
              key={`address-${a.id}`}
              address={a as BookingAddress}
              expand={expanded}
              onChange={handleChange}
            />
          ))}
    </Box>
  )
}

export default BookingAddressAttachments
